
    import '/mnt/src/components/ConfigProvider/index.md?watch=parent';
    export const demoIndex = {
  ids: ["configprovider-demo-demo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/ConfigProvider/index.md?type=demo')
};